import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import {
  MatFormField,
  MatHint,
  MatInput,
  MatLabel
} from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';

import { ChipComponent } from '@shared/components/chip/chip.component';
import { FileUploadComponent } from '@file-upload/components/file-upload/file-upload.component';
import { MbToBPipe } from '@file-upload/pipes/mb-to-b.pipe';

@Component({
  templateUrl: './style-guide.component.html',
  styleUrls: ['./style-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButton,
    MatCard,
    MatCheckbox,
    MatFormField,
    MatHint,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,

    ChipComponent,
    FileUploadComponent,
    MbToBPipe
  ]
})
export class StyleGuideComponent {}
